var map = {
	"./1.png": "f8e4",
	"./2.png": "d652",
	"./3.png": "0a5c",
	"./4.png": "8dcd",
	"./5.png": "cdba",
	"./6.png": "db26",
	"./7.png": "ca41",
	"./8.png": "aa3c",
	"./9.png": "c040"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f5c1";